module.exports = __webpack_public_path__ + "static/media/ycUSDT-logo.dcd437f3.png";